import apiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const postTenantFeaturesAdjusted = (token, id, FeaturesAdjusted) => {
    return fetch(`${apiUrl}tenants/${id}/features_adjusted`, {
        method: "POST",
        headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            FeaturesAdjusted
        })
    });
}

export default postTenantFeaturesAdjusted

